import { defineStyleConfig } from '@chakra-ui/react';

const Tabs = defineStyleConfig({
  variants: {
    line: (props) => ({
      tablist: {
        borderColor: props.colorMode === 'dark' ? 'gray.700' : 'gray.200',
      },
      tab: {
        color: props.colorMode === 'dark' ? 'text.secondary' : 'gray.500',
        _selected: {
          color: props.colorMode === 'dark' ? 'text.primary' : (props.colorScheme === 'orange' ? 'brand.orange.500' : 'brand.blue.500'),
          borderColor: props.colorScheme === 'orange' ? 'brand.orange.500' : 'brand.blue.500',
        },
        _hover: {
            color: props.colorMode === 'dark' ? 'text.primary' : 'gray.800',
        }
      },
    }),
  },
  defaultProps: {
    variant: 'line',
  },
});

export default Tabs;
